import { defineComponent as _defineComponent } from 'vue'
import FullSeatLineInfoRow from "@/components/line/FullSeatLineInfoRow.vue";
import { IFullSeatLine } from "@/domain/entities/lineInfo";
import router from "@/router";
import { useUserStore } from "@/stores/userStore";
import { RouterName } from "@/types";
import useGetLineRouteName from "@/use/useGetLineRouteName";

import { onMounted, PropType, ref } from "vue";

import InlineSvg from "vue-inline-svg";
import ScrollTopControl from "../ScrollTopControl.vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "FullSeatLinesModal",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  fullSeatLines: Array as PropType<IFullSeatLine[]>,
  default: () => [],
},
  emits: ["onClickClose"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const route = useRoute();
const userStore = useUserStore();

const scrollWrapper = ref<HTMLElement>();

const showModal = ref(true);
const onClickClose = () => {
  route.meta.onBackHandlerList.pop();
  showModal.value = false;
  setTimeout(() => {
    emit("onClickClose");
  }, 300);
};

const goToLineInfoDetail = (lineInfo: IFullSeatLine) => {
  onClickClose();
  userStore.updateSelectedLineNum(lineInfo.no);
  router.push({
    name: RouterName.LineInfoDetail,
    params: {
      lineId: lineInfo.id,
    },
  });
};

onMounted(() => {
  route.meta.onBackHandlerList.push(onClickClose);
});

const __returned__ = { emit, route, userStore, scrollWrapper, showModal, onClickClose, goToLineInfoDetail, FullSeatLineInfoRow, get useGetLineRouteName() { return useGetLineRouteName }, get InlineSvg() { return InlineSvg }, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})